module.exports = __webpack_public_path__ + "img/pizza-plate.eb23accf.png";